export default __webpack_public_path__ + "static/media/KCL-RobustRL-2025.d54f9104.pdf";